<template>
  <div class="market-search-mobile" role="dialog" aria-labelledby="marketSearchTitle" aria-modal="true">
    <CloseButton ref="closeButton" @close="close" />
    <div class="intro">
      <h3 id="marketSearchTitle" aria-label="Wähle deinen REWE Markt">Wähle deinen REWE Markt</h3>
      <div class="select-input">
        <label for="plz">Bitte gib deine PLZ ein:</label>
        <div class="input-container">
          <input
            type="text"
            maxlength="5"
            max="99999"
            value=""
            name="plz"
            id="plz"
            autocomplete="postal-code"
            :placeholder="51063"
            inputmode="numeric"
            pattern="[0-9]*"
            v-model="zip"
            @keypress="onKeypress"
            :class="{ error: error }"
            ref="input"
            data-mf-replace="**REMOVED**"
          >
        </div>

        <div class="error" v-if="error" aria-live="polite">
          Die Postleitzahl scheint leider ungültig zu sein.
        </div>

        <button class="button-primary" v-on:click.prevent="submit">
          PLZ überprüfen<i class="icon-search mobile" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="hint">
      <div class="icon">
        <img src="/assets/images/location-icon-mobile-trans.png" alt="Icon Standort" />
      </div>
      <p>
        Einfach Postleitzahl eingeben und herausfinden, welche Produkte in deinem REWE Markt angeboten werden.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { ajaxGet } from "@/helpers/ajax";
import CloseButton from "@/components/CloseButton.vue";
export default {
  name: "market-search-mobile",
  components: { CloseButton },
  data() {
    return {
      zip: null,
      error: false
    };
  },
  mounted() {
    this.$store.commit("SET_SHOW_SCROLLBAR", false);
    this.$refs.closeButton && this.$refs.closeButton.$el.focus();
    window.setTimeout(() => {
      this.$refs.input.select();
      this.$refs.input.focus();
    }, 200);
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
  },
  methods: {
    submit() {
      this.error = false;
      if (!this.zip || this.zip.length < 5) {
        this.error = true;
        this.$refs.input.select();
        return false;
      }
      this.$store.commit("SET_ZIP", this.zip);
      this.$emit("showMarketSearchResults");
    },
    close() {
      this.$store.commit("SET_SHOW_SCROLLBAR", true);
      this.$emit("close");
    },
    onKeypress(evt) {
      this.error = false;
      if (evt.keyCode == 13) {
        // "Return"
        this.submit();
        return false;
      }
      if (evt.keyCode >= 48 && evt.keyCode <= 57) {
        // 0, 1, 2, ... 9
        return true;
      }
      evt.preventDefault();
    }
  },
  computed: {
    ...mapGetters(["isMobile"])
  }
};
</script>

<style lang="scss">
@import "./MarketSearchMobile";
</style>
